module.exports = __webpack_public_path__ + "img/icon-edit-light-red.7a0959ab.svg";